import { gql } from '@apollo/client';

export default gql`
  mutation ReportThread(
    $courseId: String!
    $threadId: String!
    $input: ReportThreadInput!
  ) {
    reportThread(courseId: $courseId, threadId: $threadId, input: $input)
      @rest(
        type: "Thread"
        path: "courses/{args.courseId}/threads/{args.threadId}/report"
        method: "POST"
      ) {
      NoResponse
    }
  }
`;
